import React, { useState } from "react";
import { Flex } from "rebass/styled-components";

import { LabelReadOnly } from "../../../../Components/Form/Label";
import { Button } from "../../../../Components/Button";
import { LinkedAccountsViewModel } from "../../ViewModel";
import {
  IconWrapper,
  StyledTikTokIcon,
  UnlinkButton,
} from "../styledComponents";
import { useHistory } from "react-router-dom";
import { URLS } from "../../../../Utilities/Maps";
import { useUser } from "../../../../Hooks/useUser";
import { useIsDesktopApp } from "../../../../Hooks/useIsDesktopApp";
const { REACT_APP_BASE_URL } = process.env;
const LinkTikTok = ({ buttonText }: { buttonText: string }) => {
  const { unlinkAccount } = LinkedAccountsViewModel();
  const { allstarUser } = useUser();
  const [linked, setLinked] = useState(
    !!allstarUser?.user?.tiktok?.display_name,
  );
  const { isDesktop } = useIsDesktopApp();
  const history = useHistory();
  const tiktokUsedForSignup = allstarUser?.user?.tiktok?.usedForSignUp;
  const link = async () => {
    if (isDesktop) {
      window.parent.postMessage(
        {
          type: "openLink",
          link: `${REACT_APP_BASE_URL}${URLS.AUTH_ROUTES.TIKTOK}?flow=link&referrer=CONNECTED_ACCOUNTS`,
        },
        "*",
      );
    }

    history.push(
      `${URLS.AUTH_ROUTES.TIKTOK}?flow=link&referrer=CONNECTED_ACCOUNTS`,
    );
  };

  const unlink = async () => {
    await unlinkAccount({ variables: { accountType: "tiktok" } });
    setLinked(!linked);
  };

  return (
    <Flex pt={5} alignItems="center">
      <IconWrapper>
        <StyledTikTokIcon />
      </IconWrapper>
      {linked ? (
        <Flex width="100%" style={{ gap: "8px" }} alignItems={"center"}>
          <LabelReadOnly
            label={"TikTok"}
            text={allstarUser.user?.tiktok?.display_name}
          />
          <UnlinkButton
            size="small"
            flex={true}
            maxWidth={2}
            classification="secondary"
            onClick={() => unlink()}
            disabled={tiktokUsedForSignup}
            style={{
              cursor: tiktokUsedForSignup ? "not-allowed" : "pointer",
            }}
          >
            Unlink
          </UnlinkButton>
        </Flex>
      ) : (
        <Button
          size="small"
          flex={true}
          maxWidth={2}
          width="100%"
          classification="secondary"
          target="_blank"
          onClick={() => link()}
        >
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};

export { LinkTikTok };
